import React from "react";

export enum ICONS {
  ARROW_UP,
  ARROW_RIGHT,
  ARROW_LEFT,
  SWAP_VERTICAL,
  ALIGN_BASELINE,
  ALIGN_CENTER,
  ALIGN_FLEX_END,
  ALIGN_FLEX_START,
  ALIGN_STRETCH,
  NO_WRAP,
  WRAP,
  WRAP_REVERSE,
  JUSTIFY_FLEX_START,
  JUSTIFY_CENTER,
  JUSTIFY_FLEX_END,
  JUSTIFY_SPACE_BETWEEN,
  JUSTIFY_SPACE_EVENLY,
  ALIGN_CONTENT_FLEX_START,
  ALIGN_CONTENT_CENTER,
  ALIGN_CONTENT_FLEX_END,
  ALIGN_CONTENT_STRETCH,
  ALIGN_CONTENT_SPACE_BETWEEN,
  ALIGN_CONTENT_SPACE_AROUND,
  OVERFLOW_VISIBLE,
  OVERFLOW_HIDDEN,
  OVERFLOW_SCROLL,
  ALIGN_TEXT_CENTER,
  ALIGN_TEXT_LEFT,
  ALIGN_TEXT_RIGHT,
  ALIGN_TEXT_JUSTIFY,
  BORDERS_ALL,
  BORDERS_LEFT,
  BORDERS_TOP,
  BORDERS_BOTTOM,
  BORDERS_RIGHT,
  BORDERS_NONE,
  BORDERS_SOLID,
  BORDERS_DASHED,
  OVERFLOW_AUTO,
  PLUS,
  STAR,
  MINUS,
  ADD,
  CHEVRON_DOWN,
  CHEVRON_DOWN_ORANGE,
  CHEVRON_DOWN_BLACK,
  INFO,
  COMPONENT_NAV,
  TEXT_STRING,
  BOOLEAN,
  NUMBER,
  CODE,
  TRASH,
  WARNING,
  TEMPO_LOGO,
  TEMPO_LOGO_WHITE,
  DIVIDER,
  PADDING_LEFT,
  PADDING_TOP,
  PADDING_RIGHT,
  PADDING_BOTTOM,
  PADDING_VERTICAL,
  PADDING_HORIZONTAL,
  EXPAND_SETTING_PADDING,
  BORDER_RADIUS_TOP_LEFT,
  BORDER_RADIUS_TOP_RIGHT,
  BORDER_RADIUS_BOTTOM_LEFT,
  BORDER_RADIUS_BOTTOM_RIGHT,
  GRID_LIST,
  GRID_ICONS,
  BOOK_OPENED,
  SEARCH,
  COMPONENT,
  STORY,
  LINK_OUT,
  GLOBE,
  REFRESH,
  REFRESH_BLACK,
  WINDOW,
  AI_LOGO,
  AI_LOGO_MUTED,
  CURSOR_POINTER,
  CURSOR_POINTER_WHITE,
  CURSOR_DRAW,
  CURSOR_DRAW_WHITE,
  VSCODE,
  PENCIL,
  DEV_SERVER,
  TERMINAL,
  DEV_SERVER_LOGS,
  TABLE_HORIZONTAL,
  EXPAND,
  MINIMIZE,
  HISTORY,
  HISTORY_WHITE,
  UNDO,
  REDO,
  MOVE,
  EYE,
  CARD,
  ARROW_RIGHT_START_ON_RECTANGLE,
  CIRCLE_STOP,
  GEMINI,
}

const ICON_MAP = {
  [ICONS.ARROW_UP]: "/icons/arrow-up.svg",
  [ICONS.ARROW_RIGHT]: "/icons/arrow-right.svg",
  [ICONS.SWAP_VERTICAL]: "/icons/swap-vertical.svg",
  [ICONS.ALIGN_BASELINE]: "/icons/align-baseline.svg",
  [ICONS.ALIGN_CENTER]: "/icons/align-center.svg",
  [ICONS.ALIGN_FLEX_END]: "/icons/align-flex-end.svg",
  [ICONS.ALIGN_FLEX_START]: "/icons/align-flex-start.svg",
  [ICONS.ALIGN_STRETCH]: "/icons/align-stretch.svg",
  [ICONS.NO_WRAP]: "/icons/no-wrap.svg",
  [ICONS.WRAP]: "/icons/wrap.svg",
  [ICONS.WRAP_REVERSE]: "/icons/wrap-reverse.svg",
  [ICONS.JUSTIFY_FLEX_START]: "/icons/justify-flex-start.svg",
  [ICONS.JUSTIFY_CENTER]: "/icons/justify-center.svg",
  [ICONS.JUSTIFY_FLEX_END]: "/icons/justify-flex-end.svg",
  [ICONS.JUSTIFY_SPACE_BETWEEN]: "/icons/justify-space-between.svg",
  [ICONS.JUSTIFY_SPACE_EVENLY]: "/icons/justify-space-evenly.svg",
  [ICONS.ALIGN_CONTENT_FLEX_START]: "/icons/align-content-flex-start.svg",
  [ICONS.ALIGN_CONTENT_CENTER]: "/icons/align-content-center.svg",
  [ICONS.ALIGN_CONTENT_FLEX_END]: "/icons/align-content-flex-end.svg",
  [ICONS.ALIGN_CONTENT_STRETCH]: "/icons/align-content-stretch.svg",
  [ICONS.ALIGN_CONTENT_SPACE_BETWEEN]: "/icons/align-content-space-between.svg",
  [ICONS.ALIGN_CONTENT_SPACE_AROUND]: "/icons/align-content-space-around.svg",
  [ICONS.OVERFLOW_VISIBLE]: "/icons/overflow-visible.svg",
  [ICONS.OVERFLOW_HIDDEN]: "/icons/overflow-hidden.svg",
  [ICONS.OVERFLOW_SCROLL]: "/icons/overflow-scroll.svg",
  [ICONS.ALIGN_TEXT_CENTER]: "/icons/align-text-center.svg",
  [ICONS.ALIGN_TEXT_LEFT]: "/icons/align-text-left.svg",
  [ICONS.ALIGN_TEXT_RIGHT]: "/icons/align-text-right.svg",
  [ICONS.ALIGN_TEXT_JUSTIFY]: "/icons/align-text-justify.svg",
  [ICONS.BORDERS_ALL]: "/icons/borders-all.svg",
  [ICONS.BORDERS_LEFT]: "/icons/borders-left.svg",
  [ICONS.BORDERS_TOP]: "/icons/borders-top.svg",
  [ICONS.BORDERS_BOTTOM]: "/icons/borders-bottom.svg",
  [ICONS.BORDERS_RIGHT]: "/icons/borders-right.svg",
  [ICONS.BORDERS_NONE]: "/icons/border-none.svg",
  [ICONS.BORDERS_SOLID]: "/icons/border-solid.svg",
  [ICONS.BORDERS_DASHED]: "/icons/border-dashed.svg",
  [ICONS.OVERFLOW_AUTO]: "/icons/overflow-auto.svg",
  [ICONS.PLUS]: "/icons/plus.svg",
  [ICONS.MINUS]: "/icons/minus.svg",
  [ICONS.ADD]: "/icons/add.svg",
  [ICONS.CHEVRON_DOWN]: "/icons/chevron-down.svg",
  [ICONS.CHEVRON_DOWN_ORANGE]: "/icons/chevron-down-orange.svg",
  [ICONS.CHEVRON_DOWN_BLACK]: "/icons/chevron-down-black.svg",
  [ICONS.INFO]: "/icons/info.svg",
  [ICONS.COMPONENT_NAV]: "/icons/component.svg",
  [ICONS.TEXT_STRING]: "/icons/typography.svg",
  [ICONS.BOOLEAN]: "/icons/bool_switches.svg",
  [ICONS.NUMBER]: "/icons/number.svg",
  [ICONS.CODE]: "/icons/code.svg",
  [ICONS.TRASH]: "/icons/trash.svg",
  [ICONS.WARNING]: "/icons/warning.svg",
  [ICONS.TEMPO_LOGO]: "/icons/tempo-logo.png",
  [ICONS.TEMPO_LOGO_WHITE]: "/icons/tempo-logo-white.svg",
  [ICONS.DIVIDER]: "/icons/divider.svg",
  [ICONS.PADDING_LEFT]: "/icons/padding-left.svg",
  [ICONS.PADDING_TOP]: "/icons/padding-top.svg",
  [ICONS.PADDING_RIGHT]: "/icons/padding-right.svg",
  [ICONS.PADDING_BOTTOM]: "/icons/padding-bottom.svg",
  [ICONS.PADDING_VERTICAL]: "/icons/padding-vertical.svg",
  [ICONS.PADDING_HORIZONTAL]: "/icons/padding-horizontal.svg",
  [ICONS.EXPAND_SETTING_PADDING]: "/icons/expand-setting-padding.svg",
  [ICONS.BORDER_RADIUS_TOP_LEFT]: "/icons/border-radius-top-left.svg",
  [ICONS.BORDER_RADIUS_TOP_RIGHT]: "/icons/border-radius-top-right.svg",
  [ICONS.BORDER_RADIUS_BOTTOM_LEFT]: "/icons/border-radius-bottom-left.svg",
  [ICONS.BORDER_RADIUS_BOTTOM_RIGHT]: "/icons/border-radius-bottom-right.svg",
  [ICONS.GRID_LIST]: "/icons/grid-list.svg",
  [ICONS.GRID_ICONS]: "/icons/grid-icons.svg",
  [ICONS.BOOK_OPENED]: "/icons/book-opened.svg",
  [ICONS.SEARCH]: "/icons/search.svg",
  [ICONS.STAR]: "/icons/star.svg",
  [ICONS.COMPONENT]: "/icons/component-icon.svg",
  [ICONS.STORY]: "/icons/story.svg",
  [ICONS.LINK_OUT]: "/icons/link-out.svg",
  [ICONS.GLOBE]: "/icons/globe.svg",
  [ICONS.ARROW_LEFT]: "/icons/arrow-left.svg",
  [ICONS.REFRESH]: "/icons/refresh.svg",
  [ICONS.REFRESH_BLACK]: "/icons/refresh-black.svg",
  [ICONS.WINDOW]: "/icons/window.svg",
  [ICONS.AI_LOGO]: "/icons/ai-logo.svg",
  [ICONS.AI_LOGO_MUTED]: "/icons/ai-logo-muted.svg",
  [ICONS.CURSOR_POINTER]: "/icons/cursor-pointer.svg",
  [ICONS.CURSOR_POINTER_WHITE]: "/icons/cursor-pointer-white.svg",
  [ICONS.CURSOR_DRAW]: "/icons/cursor-draw.svg",
  [ICONS.CURSOR_DRAW_WHITE]: "/icons/cursor-draw-white.svg",
  [ICONS.VSCODE]: "/icons/vscode.svg",
  [ICONS.PENCIL]: "/icons/pencil.svg",
  [ICONS.DEV_SERVER]: "/icons/dev-server.svg",
  [ICONS.TERMINAL]: "/icons/terminal.svg",
  [ICONS.DEV_SERVER_LOGS]: "/icons/dev-server-logs.svg",
  [ICONS.TABLE_HORIZONTAL]: "/icons/table-horizontal.svg",
  [ICONS.EXPAND]: "/icons/expand.png",
  [ICONS.MINIMIZE]: "/icons/minimize.png",
  [ICONS.HISTORY]: "/icons/history.svg",
  [ICONS.HISTORY_WHITE]: "/icons/history-white.svg",
  [ICONS.UNDO]: "/icons/undo.svg",
  [ICONS.REDO]: "/icons/redo.svg",
  [ICONS.MOVE]: "/icons/move.png",
  [ICONS.EYE]: "/images/eye.png",
  [ICONS.CARD]: "/icons/card-svgrepo.svg",
  [ICONS.ARROW_RIGHT_START_ON_RECTANGLE]:
    "/icons/arrow-right-start-on-rectangle.svg",
  [ICONS.CIRCLE_STOP]: "/icons/circle-stop.svg",
  [ICONS.GEMINI]: "/icons/gemini.svg",
};

interface Props extends Partial<any> {
  style?: any;
  icon: ICONS;
  onClick?: (e: any) => void;
  className?: string;
  onMouseDown?: (e: any) => void;
  onMouseUp?: (e: any) => void;
  width?: number;
  height?: number;
}

const Icon: React.FC<Props> = React.memo(
  ({
    style,
    icon,
    onClick,
    className,
    onMouseDown,
    onMouseUp,
    width,
    height,
    ...otherProps
  }: Props) => {
    const source = ICON_MAP[icon];
    const pointerStyle = onClick ? { cursor: "pointer" } : {};
    return (
      <img
        style={{
          boxSizing: "initial",
          ...pointerStyle,
          ...style,
        }}
        src={source}
        className={"icon max-w-none " + (className ? className : "")}
        onClick={onClick}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        alt={source}
        width={width || 20}
        height={height || 20}
        draggable={false}
        {...(otherProps || {})}
      />
    );
  }
);

export default Icon;

export const MinWidthIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.182 9.18161C3.00626 9.35734 3.00626 9.64227 3.182 9.818C3.35773 9.99374 3.64266 9.99374 3.81839 9.818L5.81839 7.818C5.99413 7.64227 5.99413 7.35734 5.81839 7.18161L3.81839 5.18161C3.64266 5.00587 3.35773 5.00587 3.182 5.18161C3.00626 5.35734 3.00626 5.64227 3.182 5.818L4.4138 7.04981L0.999953 7.04981C0.751423 7.04981 0.549953 7.25128 0.549953 7.49981C0.549953 7.74833 0.751422 7.94981 0.999952 7.94981L4.4138 7.94981L3.182 9.18161Z"
        fill={color}
      />
      <path
        d="M7.50012 1C7.77626 1 8.00012 1.22386 8.00012 1.5V13.5C8.00012 13.7761 7.77626 14 7.50012 14C7.22398 14 7.00012 13.7761 7.00012 13.5V1.5C7.00012 1.22386 7.22398 1 7.50012 1Z"
        fill={color}
      />
      <path
        d="M11.8184 9.818C11.6426 9.99374 11.3577 9.99374 11.182 9.818L9.18202 7.818C9.00622 7.64227 9.00622 7.35734 9.18202 7.18161L11.182 5.18161C11.3577 5.00587 11.6426 5.00587 11.8184 5.18161C11.9941 5.35734 11.9941 5.64227 11.8184 5.818L10.5866 7.04981L14 7.04981C14.2485 7.04981 14.45 7.25128 14.45 7.49981C14.45 7.74833 14.2485 7.94981 14 7.94981L10.5866 7.94981L11.8184 9.18161C11.9941 9.35734 11.9941 9.64227 11.8184 9.818Z"
        fill={color}
      />
    </svg>
  );
};

export const MaxWidthIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.08824 5.78387C5.31604 5.60456 5.31604 5.31381 5.08824 5.13449C4.86045 4.95517 4.49111 4.95517 4.26332 5.13449L1.67085 7.17531C1.44305 7.35463 1.44305 7.64537 1.67085 7.82469L4.26332 9.86551C4.49111 10.0448 4.86045 10.0448 5.08824 9.86551C5.31604 9.68619 5.31604 9.39544 5.08824 9.21613L3.49153 7.95918H7.91669C8.23885 7.95918 8.5 7.7536 8.5 7.5C8.5 7.2464 8.23885 7.04081 7.91669 7.04081H3.49153L5.08824 5.78387Z"
        fill={color}
      />
      <path
        d="M14 1C14.2761 1 14.5 1.22386 14.5 1.5V13.5C14.5 13.7761 14.2761 14 14 14C13.7239 14 13.5 13.7761 13.5 13.5V1.5C13.5 1.22386 13.7239 1 14 1Z"
        fill={color}
      />
      <path
        d="M1 1C1.27614 1 1.5 1.22386 1.5 1.5V13.5C1.5 13.7761 1.27614 14 1 14C0.72386 14 0.5 13.7761 0.5 13.5V1.5C0.5 1.22386 0.72386 1 1 1Z"
        fill={color}
      />
      <path
        d="M9.91138 5.13449C10.1393 4.95517 10.5086 4.95517 10.7364 5.13449L13.3291 7.17531C13.557 7.35463 13.557 7.64537 13.3291 7.82469L10.7364 9.86551C10.5086 10.0448 10.1393 10.0448 9.91138 9.86551C9.68361 9.68619 9.68361 9.39545 9.91138 9.21613L11.5082 7.95918H7.08336C6.76118 7.95918 6.5 7.7536 6.5 7.5C6.5 7.2464 6.76118 7.04081 7.08336 7.04081H11.5082L9.91138 5.78387C9.68361 5.60456 9.68361 5.31381 9.91138 5.13449Z"
        fill={color}
      />
    </svg>
  );
};
